import { useState } from "react";

export default function Upload() {
  const [file, setFile] = useState(null);

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) return alert("Select a file first.");

    // Simulate upload
    alert(`Uploaded: ${file.name}`);
    
    // Example for Firebase (if integrated):
    // const storageRef = ref(storage, `uploads/${file.name}`);
    // await uploadBytes(storageRef, file);
    // const url = await getDownloadURL(storageRef);
    // Save URL to your DB
  };

  return (
    <form onSubmit={handleUpload} className="space-y-4">
      <h2 className="text-2xl font-bold">Upload Project Media</h2>
      <input
        type="file"
        accept="image/*,video/*"
        onChange={(e) => setFile(e.target.files[0])}
        className="block"
      />
      <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
        Upload
      </button>
    </form>
  );
}
